import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Spinner from '@/components/Common/Spinner';
import TransitionPortal from '@/components/Common/TransitionPortal';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

const LoadingLayout = (props: {
  children?: ReactNode;
  style?: CSSProperties;
}) => {
  const color = useColor();
  return (
    <TransitionPortal layerId="page-loading-layer" status={true}>
      <Style a="center" j="center" d="column" g="24px" style={props.style}>
        <Spinner size={32} />
        {props.children && (
          <Typo type="label2" color={color.ND60}>
            {props.children}
          </Typo>
        )}
      </Style>
    </TransitionPortal>
  );
};

const Style = styled(Flex)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.dune50};
`;

export default LoadingLayout;
